import { useHistory } from 'quartz-routing/react-router';
import { PortalsAppLayout } from 'portals-platform-lib';
import { Flex } from 'foundations-components/components/Flex';
import { Footer } from '../Footer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AppLayout = ({
  children
}) => {
  const history = useHistory();
  return /*#__PURE__*/_jsx(PortalsAppLayout, {
    history: history,
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      minBlockSize: "100%",
      children: [/*#__PURE__*/_jsx(Flex, {
        flexGrow: 1,
        children: children
      }), /*#__PURE__*/_jsx(Footer, {})]
    })
  });
};